export { default } from './ProductRichContent';